<template>
  <article
    id="warning-internet-explorer"
    class="padding-y-5xl inverted"
    style="background-color: var(--fa-dk-navy)"
  >
    <div class="container">
      <div class="warning-internet-explorer text-center tablet:text-left">
        <div class="warning-internet-explorer-decorative">
          <font-awesome-icon
            :icon="$v7.solid.faSpaceStationMoonConstruction"
            size="3x"
          />
        </div>

        <div class="tablet:margin-left-7xl">
          <div class="warning-internet-explorer-message margin-y-2xl tablet:margin-top-0">
            <h1 class="h4">
              That's No Moon!
              <strong
                class="margin-left-4xs"
                style="color: var(--fa-yellow)"
              >
                And This Isn't a Modern Browser!
              </strong>
            </h1>
            <p class="laptop:line-length-lg">
              You're using Internet Explorer, an
              <a
                href="https://techcommunity.microsoft.com/t5/microsoft-365-blog/microsoft-365-apps-say-farewell-to-internet-explorer-11-and/ba-p/1591666"
                target="_blank"
                rel="nofollow"
              >
                outdated
              </a>
              and
              <a
                href="https://blogs.windows.com/windowsexperience/2021/05/19/the-future-of-internet-explorer-on-windows-10-is-in-microsoft-edge/"
                target="_blank"
                rel="nofollow"
              >
                soon to be unsupported
              </a>
              browser. Using such a browser can make your experience on this site nowhere near Awesome, put your computer at risk, and may even lead to the dark
              side...
            </p>
          </div>

          <div class="warning-internet-explorer-action">
            <a
              class="button yellow text-nowrap"
              style="--button-background: transparent"
              href="https://browsehappy.com/"
              target="_blank"
              rel="nofollow"
            >
              <font-awesome-icon
                :icon="$v7.solid.faStarfighter"
                size="lg"
                rotation="90"
                class="margin-right-2xs"
              />
              Be a Rebel &ndash; Upgrade!
            </a>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
